<template>
  <section>
    <AppCardsGrid :items="reports">
      <template #title="report">
        {{ report.name }}
      </template>
      <template #button="report">
        {{ report.generatedReportFilePath }}
        <v-btn
          color="accent"
          text
          :href="
            ['LINK', 'FILE'].includes(report.contentDeliveryType)
              ? report.url
              : undefined
          "
          :target="
            ['LINK', 'FILE'].includes(report.contentDeliveryType)
              ? '_blank'
              : undefined
          "
          @click="
            report.contentDeliveryType == 'IFRAME'
              ? [(selectedReport = report), (dialog = true)]
              : null
          "
        >
          <span style="font-size: 16px; font-weight: normal">
            <template v-if="report.contentDeliveryType == 'IFRAME'">
              {{ $t("common:view.button") }}
              <v-icon right style="font-size: 16px">
                $iconCircleArrowRight
              </v-icon>
            </template>
            <template v-else-if="report.contentDeliveryType == 'FILE'">
              {{ $t("common:download.button") }}
              <v-icon right style="font-size: 15px"> $iconDownload </v-icon>
            </template>
            <template v-else-if="report.contentDeliveryType == 'LINK'">
              {{ $t("common:navigate.button") }}
              <v-icon right style="font-size: 15px"> $iconArrowOutSquare </v-icon>
            </template>
          </span>
        </v-btn>
      </template>
    </AppCardsGrid>

    <ReportViewerDialog
      v-model="dialog"
      :selected-report.sync="selectedReport"
      :reports-dropdown="reports"
    />
  </section>
</template>
<script>
import ReportViewerDialog from "@/components/admin/ReportViewerDialog.vue";
import AppCardsGrid from "@elements/AppCardsGrid.vue";

export default {
  name: "ReportViewerTab",
  components: { AppCardsGrid, ReportViewerDialog },
  props: {
    reports: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedReport: null,
      lazyDialog: false,
      reportEndpoint: process.env.VUE_APP_API_URL
    };
  },
  computed: {
    dialog: {
      get() {
        return this.lazyDialog;
      },
      set(v) {
        if (v == false) {
          this.selectedReport = null;
        }
        this.lazyDialog = v;
      }
    }
  },
  fragments: {
    reports: ReportViewerDialog.fragments.reports
  }
};
</script>
